'use client'

import { useTranslations } from 'next-intl'
import { Badge } from '@/components/ui/badge'
import { JobStatusEnum } from '@/enums'

type PropsType = {
  status: JobStatusEnum
}

const JobStatusBadge = ({ status }: PropsType) => {
  const t = useTranslations()

  const statusConfig = {
    [JobStatusEnum.PENDING]: {
      variant: 'secondary' as const,
      className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300'
    },
    [JobStatusEnum.IN_PROGRESS]: {
      variant: 'default' as const,
      className: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300'
    },
    [JobStatusEnum.COMPLETED]: {
      variant: 'default' as const,
      className: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
    },
    [JobStatusEnum.FAILED]: {
      variant: 'destructive' as const,
      className: ''
    },
    [JobStatusEnum.CANCELED]: {
      variant: 'outline' as const,
      className: 'text-gray-600 dark:text-gray-400'
    }
  }

  const config = statusConfig[status] || statusConfig[JobStatusEnum.PENDING]

  return (
    <Badge variant={config.variant} className={config.className}>
      {t(status)}
    </Badge>
  )
}

export default JobStatusBadge
